import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddressDetail_create, AddressDetail_delete, AddressDetail_readAll, AddressDetail_readById, AddressDetail_readByMasterId, AddressDetail_update } from 'src/app/GlobalVariables';
import { AddressDetailCreateRequestDTO, AddressDetailDTO, AddressDetailUpdateRequestDTO, AddressDetailReadByIdRequestDTO, AddressDetailList, AddressDetailDeleteRequestDTO, AddressDetailReadByMasterIdRequestDTO } from './address-detail.interface';

@Injectable({
  providedIn: 'root'
})
export class AddressDetailService {

  constructor() { }

  http = inject(HttpClient)



  AddressDetail_create(data: AddressDetailCreateRequestDTO): Observable<AddressDetailDTO> {
    return this.http.post<AddressDetailDTO>(AddressDetail_create, data)
  }
  AddressDetail_update(data: AddressDetailUpdateRequestDTO): Observable<AddressDetailDTO> {
    return this.http.post<AddressDetailDTO>(AddressDetail_update, data)
  }
  AddressDetail_readById(data: AddressDetailReadByIdRequestDTO): Observable<AddressDetailDTO> {
    return this.http.post<AddressDetailDTO>(AddressDetail_readById, data)
  }
  AddressDetail_readAll(): Observable<AddressDetailList> {
    return this.http.get<AddressDetailList>(AddressDetail_readAll)
  }
  AddressDetail_readByMasterId(data: AddressDetailReadByMasterIdRequestDTO): Observable<AddressDetailList> {
    return this.http.post<AddressDetailList>(AddressDetail_readByMasterId, data)
  }
  AddressDetail_delete(data: AddressDetailDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(AddressDetail_delete, data)
  }
}
